import { NextRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { IFintooResponse } from '../types';
import { partnerPagesRedirection, partnersApi } from '../utils';

export const useForPartnerCall = ({
  router,
}: {
  router: NextRouter;
}): {
  onPageClick: (
    e: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement | HTMLDivElement>
  ) => void;
} => {
  const [partnerData, setPartnerData] = useState<IFintooResponse | null>(null);
  useEffect(() => {
    const partnerSlug = String(router.query?.static);
    if (partnerSlug && partnersApi[partnerSlug]) {
      partnersApi[partnerSlug]
        ?.partnerApiCall()
        .then((data) => {
          setPartnerData(data);
        })
        .catch(() => {
          setPartnerData(null);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const onPageClick = (
    e: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement | HTMLDivElement>
  ) => {
    if (e && e.target) partnerPagesRedirection({ e, router, partnerData });
  };
  return { onPageClick };
};
